var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"slice-image-full relative z-10",attrs:{"data-menu-image":_vm.slice.primary.image.url}},[_c('resp-img',{attrs:{"image":_vm.slice.primary.image}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }